import { useContext, useEffect } from 'react';
import { useVideoGrid } from '../../../pages/hooks';
import { Participant } from '../../../components';
import { VideoCallContext } from '../../../core';

export function GridView() {
  const {
    room,
    remoteParticipants,
    handleParticipantClick,
    selectedParticipantInfo,
    setSelectedParticipantInfo,
  } = useContext(VideoCallContext);
  const { attachRef } = useVideoGrid();

  useEffect(() => {
    if (!room) {
      return;
    }
    if (
      selectedParticipantInfo?.participant.state === 'disconnected' ||
      !remoteParticipants.length
    ) {
      setSelectedParticipantInfo(null);
    }
  }, [remoteParticipants]);

  return (
    <div id="grid-view" ref={attachRef}>
      {remoteParticipants?.map((participant) => (
        <Participant
          participant={participant}
          key={participant?.sid}
          participantType="Remote"
          participantClickHandler={handleParticipantClick}
        />
      ))}
      <Participant
        participant={room?.localParticipant!}
        key={room?.localParticipant.sid}
        participantType="Local"
        participantClickHandler={handleParticipantClick}
      />
    </div>
  );
}
